module.exports = __webpack_public_path__ + "images/般蓝pr长图_04.jpg?v=a02ae8f9";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/zhongduan3/般蓝pr长图_04.jpg
 ** module id = 181
 ** module chunks = 1 2
 **/